import React from 'react';
import styles from './Employee.css';

class Employee extends React.Component {
  render() {
    return (
      <div className={styles['container-full-nosub']} id="moka-employee">
        <div className={`box-report-child ${styles.container}`}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Employee;
